var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchQuery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#e8eaed",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70-424q-13-9-15.5-24.5T60-478l122-196q22-35 62.5-37.5T311-683l49 57 95-154q23-38 66.5-38.5T589-782l51 76 112-178q9-15 26.5-18.5T810-895q13 9 15.5 24.5T820-841L708-663q-23 37-66.5 37T574-662l-51-76-95 154q-21 35-61.5 38T300-574l-50-58-122 197q-9 15-26.5 18.5T70-424Zm510 184q42 0 71-29t29-71q0-42-29-71t-71-29q-42 0-71 29t-29 71q0 42 29 71t71 29Zm0 80q-75 0-127.5-52.5T400-340q0-75 52.5-127.5T580-520q75 0 127.5 52.5T760-340q0 26-7 50.5T732-244l80 80q11 11 11 28t-11 28q-11 11-28 11t-28-11l-80-80q-21 14-45.5 21t-50.5 7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchQuery);
export default __webpack_public_path__ + "static/media/searchQuery.d8517eb421336a967c280d411886ba69.svg";
export { ForwardRef as ReactComponent };